'use strict';

const analytics = require('./src/utils/analytics');

require('./src/assets/scss/init.scss');
// Ensure the Tailwind cyberpunk styles are loaded globally across all templates
require('./src/assets/styles/main.css');

exports.onClientEntry = () => {
  analytics.wireClickTracking();
};

exports.onRouteUpdate = ({ location }) => {
  analytics.onRouteUpdate(location);
};
